import { useContext ,useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from "react-router-dom";
import AuthContext from '../contexts/AuthContext';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import { upperCaseFirst } from "upper-case-first";
import getProductCollections from '../utils/getProductCollections';
import { Storage } from 'aws-amplify';


export const MoveProductsPage = (params) => {
  const { authState } = useContext(AuthContext);
  let { collection, productType } = useParams();
  const { data } = useLocation();
  const productSKUsToMove = data?.productSKUsToMove;
  const [skusToMove, setSKUsToMove] = useState(productSKUsToMove || []);
  const [skusToMoveText, setSKUsToMoveText] = useState(skusToMove.join('\n'));
  const [productCollections, setProductCollections] = useState([]);
  const [fromCollection, setFromCollection] = useState(collection || 'facecake');
  const [fromCollectionProducts, setFromCollectionProducts] = useState();
  const [toCollection, setToCollection] = useState('');
  const [toCollectionProducts, setToCollectionProducts] = useState();
  const [move, setMove] = useState({folders: true, images: true, metadata: true, models: true});
  const [copyFilesSelected, setCopyFilesSelected] = useState(false);
  const [disableMoveRadio, setDisableMoveRadio] = useState(false);
  const [output, setOutput] = useState('');
  const [movingFiles, setMovingFiles] = useState(false);
  const outputRef = useRef();
  if (!productType) { productType = 'eyewear'; }

  // get available collections
  useEffect(() => {
    async function fetchData() {
      // XXX: get all available collections and search for searchString
      const userPermissions = authState?.userPermissions;
      const usersCollections = Object.keys(userPermissions);
      const productCollections = await getProductCollections(
        usersCollections
      );
      setProductCollections(productCollections);
    }
    fetchData();
  }, [authState?.userPermissions]);

  // get products
  useEffect(() => {
    if (toCollection) {
      Storage.get(`p/${toCollection}/products.json`, {
        download: true,
        cacheControl: 'no-cache',
      })
        .then((res) => {
          res.Body.text().then((resText) => {
            const currentToCollectionProducts = JSON.parse(resText);
            setToCollectionProducts(currentToCollectionProducts);
          });
        })
        .catch((err) => console.warn(err));
    }
  }, [toCollection]);
  // get products
  useEffect(() => {
    if (fromCollection) {
      Storage.get(`p/${fromCollection}/products.json`, {
        download: true,
        cacheControl: 'no-cache',
      })
        .then((res) => {
          res.Body.text().then((resText) => {
            const currentFromCollectionProducts = JSON.parse(resText);
            setFromCollectionProducts(currentFromCollectionProducts);
          });
        })
        .catch((err) => console.warn(err));
    }
  }, [fromCollection]);
  // scroll output to bottom
  useEffect(() => {
    outputRef.current.scrollTop = outputRef.current.scrollHeight;
  }, [output]);

  const handleSKUsToMoveChange = (e) => {
    const value = e.target.value;
    setSKUsToMoveText(value);
    const skusArray = value
      ?.toLowerCase()
      ?.replace(/[^0-9a-z\n]/gi, '')
      ?.split('\n');
    setSKUsToMove(skusArray);
  };

  const handleCollectionChange = ({collectionType, value}) => {
    if (collectionType === 'fromCollection') {
      setFromCollection(value.toLowerCase());
    } else {
      setToCollection(value.toLowerCase());
    }
  };

  const handleMoveCheckboxChange = (e) => {
    const moveWhat = e.target.id;
    const checked = e.target.checked;
    setMove({ ...move, [moveWhat]: checked });
    // unselect move if not all checked
    if (Object.values({ ...move, [moveWhat]: checked }).includes(false)) {
      setCopyFilesSelected(true);
      setDisableMoveRadio(true);
    } else {
      setDisableMoveRadio(false);
    }
  };

  const handleMoveCopyRadioChange = (e) => {
    let newValue = e.target.id === 'copy';
    // if any move types unchecked, force copy
    if (Object.values(move).includes(false)) {
      newValue = true;
    }
    setCopyFilesSelected(newValue);
  }

  const moveProducts = async () => {
    // newOutput is verbose display of progress
    let newOutput = output;
    let successSKUFiles = {};
    let failSKUs = [];
    // XXX: get list of files for each SKU
    const getFileLists = async (sku) => {
      try {
        const thisSKUFiles = await Storage.list(`p/${fromCollection}/${sku}/`);
        // output error
        if (thisSKUFiles.length === 0) {
          newOutput += `ERROR FOR SKU ${sku}: NO FILES FOUND\n`;
          setOutput(newOutput);
          failSKUs.push(sku);
        } else {
          newOutput += `\n\n\n##################################\nFound ${thisSKUFiles.length} files for SKU ${sku}\n`;
          setOutput(newOutput);
          successSKUFiles[sku] = thisSKUFiles;
        }
      } catch (err) {
        newOutput += `ERROR FOR SKU ${sku}: ${err}\n`;
        setOutput(newOutput);
        failSKUs.push(sku);
      }
    };
    // XXX: copy a single file
    const copyFile = async (skuFile, sku) => {
      const oldS3Key = skuFile.key;
      // change the file path by replacing the collection name in the key
      const newS3Key =
        `p/${toCollection}/` + oldS3Key.split(`p/${fromCollection}/`)?.[1];
      // get the subdirectory name
      const subdir = newS3Key.split(`p/${toCollection}/${sku}/`)?.[1]?.split('/')[0];
      const extension = oldS3Key?.split('.')?.pop();
      const imageExtensions = ['png', 'jpg', 'jpeg', 'gif', 'webp'];
      // check if 
      // get info and check whether or not to write
      let moveFile = false;
      let fileType;
      switch (true) {
        case skuFile.size === 0:
          fileType = 'folder';
          if (move.folders) { moveFile = true; }
          break;
        case imageExtensions.includes(extension.toLowerCase()):
          if (move.images && subdir === 'images') { moveFile = true; }
          if (move.models && subdir === 'model') { moveFile = true; }
          break;
        case extension === 'json':
        case extension === 'gltf':
          if (move.metadata && subdir === 'metadata') { moveFile = true; }
          if (move.models && subdir === 'model') { moveFile = true; }
          fileType = 'text';
          break;
        default:
          if (move.models && subdir === 'model') { moveFile = true; }
          fileType = 'blob';
          break;
      }
      // "move" this file if it's okay
      if (moveFile) {
        // XXX: write folder
        if (fileType === 'folder') {
          await Storage.put(newS3Key, null, {
            level: 'public',
          });
          newOutput += `CREATED DIRECTORY: ${newS3Key}\n`;
          setOutput(newOutput);
        // XXX: get and then write text files
        } else if (fileType === 'text') {
          // get file
          const res = await Storage.get(oldS3Key, { download: true });
          const contentType = res.ContentType;
          // write file
          let resText = await res.Body.text();
          // change any refernces to the origin collection to the destination collection
          resText = resText.replaceAll(`/p/${fromCollection}/${sku}/`, `/p/${toCollection}/${sku}/`);
          await Storage.put(newS3Key, resText, {
            level: 'public',
            contentType: contentType,
            cacheControl: 'no-cache',
          });
          newOutput += `COPIED FILE: ${newS3Key}\n`;
          setOutput(newOutput);
        // XXX: get and then write blob files
        } else {
          // get file
          const res = await Storage.get(oldS3Key, { download: true });
          const contentType = res.ContentType;
          // write file
          await Storage.put(newS3Key, res.Body, {
            level: 'public',
            contentType: contentType,
            cacheControl: 'no-cache',
          });
          newOutput += `COPIED FILE: ${newS3Key}\n`;
          setOutput(newOutput);
        }
        // if user choosing to move the files, then delete the files from origin folder
        if (copyFilesSelected === false) {
          await Storage.remove(oldS3Key);
          newOutput += `REMOVED SOURCE FILE: ${oldS3Key}\n`;
          setOutput(newOutput);
        }
      }
    };
    // XXX: copy all the files for one SKU
    const copyFiles = async (sku) => {
      const skuFiles = successSKUFiles[sku];
      if (skuFiles) {
        // loop through each file and copy it
        for (let index = 0; index < skuFiles.length; index++) {
          const skuFile = skuFiles[index];
          await copyFile(skuFile, sku);
        }
      }
    };
    // XXX: update products.json in destination collection
    const updateDestinationCollectionProductsJSON = async (sku) => {
      // XXX: write products to desitnation collection product.js
      const addSKUs = Object.keys(successSKUFiles).filter(
        (sku) =>
          toCollectionProducts[productType].productSKUs.includes(sku) === false
      );
      const newToCollectionProducts = {
        ...toCollectionProducts,
        [productType]: {
          productSKUs: [
            ...toCollectionProducts[productType].productSKUs,
            ...addSKUs,
          ],
        },
      };
      Storage.put(
        `p/${toCollection}/products.json`,
        JSON.stringify(newToCollectionProducts, null, 2),
        {
          level: 'public',
          contentType: 'application/json',
          cacheControl: 'no-cache',
        }
      );
      setToCollectionProducts(newToCollectionProducts);
      newOutput += `ADDED SKUS TO ${toCollection} PRODUCTS.JSON \n`;
      setOutput(newOutput);
    };
    // XXX: remove products from origin collection product.json
    const updateOriginCollectionProductsJSON = async (sku) => {
      const removeSKUs = Object.keys(successSKUFiles);
      const newFromCollectionProducts = {
        ...fromCollectionProducts,
        [productType]: {
          productSKUs: fromCollectionProducts[productType].productSKUs.filter(
            (sku) => removeSKUs.includes(sku) === false
          ),
        },
      };
      Storage.put(
        `p/${fromCollection}/products.json`,
        JSON.stringify(newFromCollectionProducts, null, 2),
        {
          level: 'public',
          contentType: 'application/json',
          cacheControl: 'no-cache',
        }
      );
      setFromCollectionProducts(newFromCollectionProducts);
      newOutput += `REMOVED SKUS ${fromCollection} FROM PRODUCTS.JSON \n`;
      setOutput(newOutput);
      setMovingFiles(false);
    };
    // XXX: Loop through the SKUs and move/copy the products IF toCollection is defined
    if (toCollection !== '' && skusToMove.length > 0) {
      for (let index = 0; index < skusToMove.length; index++) {
        try {
          setMovingFiles(true);
          const sku = skusToMove[index];
          await getFileLists(sku);
          await copyFiles(sku);
          await updateDestinationCollectionProductsJSON(sku);
          if (copyFilesSelected === false) {
            await updateOriginCollectionProductsJSON(sku);
          }
          setMovingFiles(false);
        } catch (err) {
          newOutput += `ERROR FOR SKU ${skusToMove[index]}: ${err}\n`;
          setOutput(newOutput);
          failSKUs.push(skusToMove[index]);
          setMovingFiles(false);
        }
      }
      newOutput += `OPERATION COMPLETED\n`;
      if (failSKUs.length) {
        newOutput += `THESE SKUS HAD ERRORS:\n${failSKUs.join('\n')}\n`;
      }
      setOutput(newOutput);
    } else if (skusToMove.length === 0) {
      newOutput += `ERROR: MUST ENTER AT LEAST ONE SKU TO MOVE\n`;
      setOutput(newOutput);
    } else {
      newOutput += `ERROR: MUST SPECIFY "TO COLLECTION"\n`;
      setOutput(newOutput);
    }
  };

  return (
    <Container fluid className="px-1 px-sm-1">
      <Row className="px-1 px-sm-3">
        <Col className="px-1 px-sm-3">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item active">MOVE PRODUCTS</li>
            </ol>
          </nav>
        </Col>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs md="auto">
          <Card>
            <Card.Text as="div">
              <Form>
                <Form.Row className="px-3 pt-3">
                  <Form.Group
                    as={Col}
                    className="px-1 px-sm-3"
                    controlId="skusToMove"
                  >
                    <Form.Label>SKUs to Move</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={10}
                      size="sm"
                      value={skusToMoveText}
                      onChange={handleSKUsToMoveChange}
                    />
                  </Form.Group>
                </Form.Row>
                <Form.Row className="px-4">
                  <Form.Group as={Col} controlId="productType">
                    <Form.Label as="div">Product Type</Form.Label>
                    <Form.Control readOnly={true} defaultValue={productType} />
                  </Form.Group>
                </Form.Row>
                <Form.Row className="px-4">
                  <Form.Group as={Col} controlId="fromCollection">
                    <Form.Label>From Collection</Form.Label>
                    <Form.Control
                      as="select"
                      size="sm"
                      custom
                      value={fromCollection}
                      onChange={(e) =>
                        handleCollectionChange({
                          collectionType: 'fromCollection',
                          value: e.target.value,
                        })
                      }
                    >
                      {productCollections.map((productCollection) => (
                        <option
                          key={Object.keys(productCollection)[0]}
                          value={Object.keys(productCollection)[0]}
                        >
                          {Object.keys(productCollection)[0].toUpperCase()}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <Form.Row className="px-4 pb-0">
                  <Form.Group as={Col} controlId="toCollection">
                    <Form.Label>To Collection</Form.Label>
                    <Form.Control
                      as="select"
                      size="sm"
                      custom
                      value={toCollection}
                      onChange={(e) =>
                        handleCollectionChange({
                          collectionType: 'toCollection',
                          value: e.target.value,
                        })
                      }
                    >
                      <option value=""></option>
                      {productCollections
                        .filter((pc) => Object.keys(pc)[0] !== fromCollection)
                        .map((productCollection) => (
                          <option
                            key={Object.keys(productCollection)[0]}
                            value={Object.keys(productCollection)[0]}
                          >
                            {Object.keys(productCollection)[0].toUpperCase()}
                          </option>
                        ))}
                    </Form.Control>
                  </Form.Group>
                </Form.Row>
                <Form.Row className="px-4 pb-0">
                  <Form.Group as={Col}>
                    {['folders', 'images', 'metadata', 'models'].map(
                      (moveWhat) => (
                        <Form.Check
                          inline
                          key={moveWhat}
                          checked={move[moveWhat]}
                          label={upperCaseFirst(moveWhat)}
                          type="checkbox"
                          id={moveWhat}
                          onChange={handleMoveCheckboxChange}
                        />
                      )
                    )}
                  </Form.Group>
                </Form.Row>
                <Form.Row className="px-4 pb-0">
                  <Form.Group as={Col}>
                    <Form.Check
                      inline
                      checked={copyFilesSelected === false}
                      disabled={disableMoveRadio}
                      label="Move"
                      type="radio"
                      id="move"
                      onChange={handleMoveCopyRadioChange}
                    />
                    <Form.Check
                      inline
                      checked={copyFilesSelected}
                      label="Copy"
                      type="radio"
                      id="copy"
                      onChange={handleMoveCopyRadioChange}
                    />
                    <br />
                    {disableMoveRadio === true ? '(select all types to enable move)': ''}
                  </Form.Group>
                  <Col className="pb-4" md="auto">
                    {movingFiles ? (
                      `${copyFilesSelected ? 'Copying' : 'Moving'} products...`
                    ) : (
                      <Button onClick={moveProducts}>
                        {copyFilesSelected ? 'Copy' : 'Move'}
                      </Button>
                    )}
                  </Col>
                </Form.Row>
              </Form>
            </Card.Text>
          </Card>
        </Col>
        <Col xs md={6}>
          <Card>
            <Card.Text as="div">
              <Form>
                <Form.Row className="px-3 pt-3 pb-2">
                  <Form.Group
                    as={Col}
                    size="sm"
                    className="px-1 px-sm-3"
                    controlId="output"
                  >
                    <Form.Label>Output</Form.Label>
                    <Form.Control
                      ref={outputRef}
                      as="textarea"
                      rows={20}
                      size="sm"
                      readOnly={true}
                      value={output}
                    />
                  </Form.Group>
                </Form.Row>
              </Form>
            </Card.Text>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};